import { render } from "./ComposeMessage.vue?vue&type=template&id=b8c7ab52&scoped=true"
import script from "./ComposeMessage.vue?vue&type=script&lang=js"
export * from "./ComposeMessage.vue?vue&type=script&lang=js"

import "./ComposeMessage.vue?vue&type=style&index=0&id=b8c7ab52&scoped=true&lang=css"

import exportComponent from "/home/forge/driver.blackwidow.org.za/releases/80919820/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c7ab52"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QItemLabel,QForm,QList,QItem,QItemSection,QInput,QBtn,QFooter});
